(function() {

    "use strict";

    require('popper.js');
    require('bootstrap');

    var $ = require('jquery'),
        isMobile = require('ismobilejs'),
        moment = require('moment'),
        momentLocale = require('moment/locale/de'),
        Pikaday = require('pikaday')
    ;

    window.$ = $;

    if (!isMobile.any) {
        var intro = $('.intro'),
            ibpy = parseFloat(intro.css('background-position').split(' ')[1])
        ;

        $(window).on('scroll', function() {
            var sy = ibpy + (window.scrollY / 2);
            intro.css('background-position-y', sy + 'px');
        }).trigger('scroll');
    }

    $('#results tbody tr').on('click', function() {
        var url = $(this).find('th a').attr('href');
        window.location.href = url;
    });

    $('.infobox').on('click', function(e) {
        var url = $(this).find('h3 a').attr('href');
        window.location.href = url;
    });

    $('.accordion dt').on('click', function() {
        $(this).toggleClass('open').next('dd').slideToggle();
    });

    var minDate = moment(),
        maxDate = moment().add(1, 'year');
    $('input.date').each(function() {
        new Pikaday({
            field: this,
            format: moment.localeData()._longDateFormat.L,
            minDate: minDate.toDate(),
            maxDate: maxDate.toDate(),
            i18n: {
                months: moment.localeData()._months,
                weekdays: moment.localeData()._weekdays,
                weekdaysShort: moment.localeData()._weekdaysShort
            }
        });
    });
})();
